<script setup lang="ts">
/**
 * Component to display the list of sponsors that provided extensions to the healthcenter.
 */

import {storeToRefs} from "pinia";
import {useSystemStore} from "@/stores/system.store";
import {computed} from "vue";
import HomeSponsoredExtensionCard from "@/home/components/HomeSponsoredExtensionCard.vue";
import Icon from "@/core/components/icon/Icon.vue";
import {EntityTypeID} from "@/core/interfaces/Entity";

const {environment} = storeToRefs(useSystemStore());

const sponsors = computed(() => {
    return environment.value?.entity.sponsorshipSponsors?.filter(sponsor => sponsor.entityTypeId !== EntityTypeID.HEALTHCENTER) ?? [];
});

const grouping = computed(() => {
    return environment.value?.entity?.grouping;
});
</script>

<template>
  <div v-if="sponsors || grouping" class="bg-[#DDDDF5] space-y-2">
    <slot name="title">
      <h1 class="text-black flex-1">
        🎁 Modules gratuits <span class="text-primary text-sm font-normal">
          - Profitez des modules offerts par vos partenaires
        </span>
      </h1>
    </slot>
    <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-x-6 gap-y-3">
      <router-link
        v-for="(sponsor, index) in sponsors ?? []" :key="index"
        :to="{name: 'sponsorship-extensions', params: {sponsorId: sponsor.id}}"
      >
        <HomeSponsoredExtensionCard
          :name="sponsor.entity.name"
          :logo-path="sponsor.entity.branding?.logo?.renderPath"
        />
      </router-link>
      <router-link v-if="grouping?.is_partner" :to="{name: 'grouping'}">
        <HomeSponsoredExtensionCard :name="grouping.name" :logo-path="grouping.branding?.logo?.renderPath" />
      </router-link>
      <router-link :to="{name: 'disruption-logistics'}">
        <HomeSponsoredExtensionCard name="Rupture">
          <template #logo>
            <div class="w-16 h-16 flex items-center justify-center">
              <Icon name="mdi-truck" :size="30" />
            </div>
          </template>
        </HomeSponsoredExtensionCard>
      </router-link>
      <router-link :to="{name: 'contests'}">
        <HomeSponsoredExtensionCard :prefix-name="false" name="Les challenges">
          <template #logo>
            <div class="w-16 h-16 flex items-center justify-center">
              <Icon name="mdi-trophy" :size="30" />
            </div>
          </template>
        </HomeSponsoredExtensionCard>
      </router-link>
      <slot />
    </div>
  </div>
</template>

<style scoped>

</style>
